import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type WorkspaceSidebarSectionProps = ComponentPropsWithoutRef<'section'>;

export const WorkspaceSidebarSection = memo(
  forwardRef<HTMLDivElement, WorkspaceSidebarSectionProps>(({ className, ...restOfProps }, forwardedRef) => {
    return <section className={cn('flex shrink-0 flex-col', className)} {...restOfProps} ref={forwardedRef} />;
  }),
);

WorkspaceSidebarSection.displayName = 'WorkspaceSidebarSection';
